import type { GraphEdgeSettingsId } from '@ipfabric/utils';
import {
  type OptionalArray,
  resolveOptionalArray,
} from '@ipfabric/utils/array/OptionalArray';
import { setEdgeProps } from 'components/Graph/helpers/setEdgeProps';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetGroupedEdgeCommand {
  edgeSettingsId: OptionalArray<GraphEdgeSettingsId>;
  grouped: boolean;
}

export const setGroupedEdge: GraphCommandFactory<SetGroupedEdgeCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      for (const edgeSettingsId of resolveOptionalArray(
        command.edgeSettingsId,
      )) {
        setEdgeProps(draft, 'grouped', command.grouped, edgeSettingsId);
      }
    });
  };
